export function isNULL(stringData) {
  var isEmpty = false;
  if (
    typeof stringData == "undefined" ||
    stringData == null ||
    stringData == ""
  ) {
    isEmpty = true;
    return isEmpty;
  }
  //为空或全部为空格
  if (stringData.match(/^[ ]*$/)) {
    isEmpty = true;
  }
  return isEmpty;
}
export function isTelPhone(phoneNumber) {
  if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(phoneNumber)) {
    return false;
  }
  return true;
}
export function isNumber(val) {
  var regPos = /^\d+(\.\d+)?$/; //非负浮点数
  //var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数   || regNeg.test(val)
  if (regPos.test(val)) {
    return true;
  } else {
    return false;
  }
}

export function checkUserName(val) {
  var re = /^[0-9a-zA-Z]*$/g; //判断字符串是否为数字和字母组合     //判断正整数 /^[1-9]+[0-9]*]*$/
  if (!re.test(val)) {
    return false;
  } else {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/utils/stringUtils.js